import { render, staticRenderFns } from "./email.vue?vue&type=template&id=35c0592a&scoped=true&lang=html&"
import script from "./email.vue?vue&type=script&lang=js&"
export * from "./email.vue?vue&type=script&lang=js&"
import style0 from "./email.vue?vue&type=style&index=0&id=35c0592a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c0592a",
  null
  
)

export default component.exports